import { consumeRoutePrefetch, startRoutePrefetch } from '@/lib/api/routePrefetch'
import { fetchClubBySlug, fetchPublicClubs, type FetchClubBySlugResult } from './api'
import type { PublicClubsResponse } from './types'

/**
 * Route-entry prefetch for the clubs routes (perf F7). Keys live here
 * so the router's entry components and the page hooks agree on them.
 */

/** The list response is viewer-specific (joined flags ride the token),
 * so prefetch entries are keyed by viewer kind and a consumer only
 * takes a matching one — an anonymous prefetch must never satisfy a
 * signed-in load. */
export type ClubsListViewer = 'anon' | 'authed'

function clubsListKey(viewer: ClubsListViewer): string {
  return `clubs:list:${viewer}`
}

function clubBySlugKey(slug: string): string {
  return `clubs:by-slug:${slug}`
}

/** Unfiltered list only — the page's first load (filters start empty);
 * filtered reloads go straight to the network. */
export function prefetchClubsList(viewer: ClubsListViewer): void {
  startRoutePrefetch(clubsListKey(viewer), () => fetchPublicClubs())
}

export function consumeClubsListPrefetch(viewer: ClubsListViewer): Promise<PublicClubsResponse> | null {
  return consumeRoutePrefetch<PublicClubsResponse>(clubsListKey(viewer))
}

export function prefetchClubBySlug(slug: string): void {
  startRoutePrefetch(clubBySlugKey(slug), () => fetchClubBySlug(slug))
}

export function consumeClubBySlugPrefetch(slug: string): Promise<FetchClubBySlugResult> | null {
  return consumeRoutePrefetch<FetchClubBySlugResult>(clubBySlugKey(slug))
}
